// extracted by extract-css-chunks-webpack-plugin
module.exports = {"quote":"css-x9A2G47lxO","quote__light":"css-1x3kvscijn"};